"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useRef } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
const testimonials = [{
  author: "Marcus T.",
  quote: "The Trust Foundation didn't just give me a second chance; they gave me the tools to build a life I'm proud of.",
  position: "Program Graduate"
}, {
  author: "Sarah L.",
  quote: "Seeing the transformation in our community members through mentorship has been the most rewarding journey of my career.",
  position: "Community Partner"
}, {
  author: "David W.",
  quote: "Their commitment to dignity and stability is exactly what our neighborhood needed to foster real, lasting change.",
  position: "Founders Circle Member"
}];
export default function ClientSuccessStories() {
  const watermarkRef = useRef<HTMLDivElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!watermarkRef.current) return;
    const {
      clientX,
      clientY
    } = e;
    const moveX = (clientX / window.innerWidth - 0.5) * 40;
    const moveY = (clientY / window.innerHeight - 0.5) * 40;
    watermarkRef.current.style.transform = `translate(${moveX}px, ${moveY}px)`;
  };
  return <section data-section-id="222908" id="voices-of-hope" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-36 flex items-center min-h-[80vh]" onMouseMove={handleMouseMove}>
      {}
      <div ref={watermarkRef} className="pointer-events-none absolute inset-0 flex items-center justify-center transition-transform duration-1000 ease-out" aria-hidden="true">
        <span className="text-[25vw] font-serif font-bold leading-none tracking-tighter text-primary/[0.03] select-none">
          TRUST
        </span>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-8">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="mx-auto w-full max-w-5xl">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center space-y-12 px-4 text-center sm:px-12">
                  <blockquote className="max-w-4xl">
                    <p className="font-serif text-3xl italic font-medium leading-tight tracking-tight md:text-[42px] md:leading-snug text-foreground/95">
                      "{testimonial.quote}"
                    </p>
                  </blockquote>

                  <div className="flex flex-col items-center gap-4">
                    <SafeHydrate><Avatar className="size-14 border border-primary/20 bg-secondary/10 shadow-md">
                      <AvatarFallback className="bg-transparent font-mono text-lg text-primary">
                        {testimonial.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="space-y-1">
                      <div className="font-default font-semibold tracking-wide text-foreground text-lg">
                        {testimonial.author}
                      </div>
                      <div className="font-mono text-xs uppercase tracking-widest text-primary/80">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="mt-16 flex items-center justify-center gap-6">
            <CarouselPrevious variant="ghost" className="static translate-x-0 translate-y-0 size-12 rounded-full border border-border/30 bg-secondary/5 hover:bg-primary/10 hover:border-primary/40 text-foreground/50 hover:text-primary transition-all duration-300 [&_svg]:size-5 [&_svg]:stroke-[1.5px]" />
            <CarouselNext variant="ghost" className="static translate-x-0 translate-y-0 size-12 rounded-full border border-border/30 bg-secondary/5 hover:bg-primary/10 hover:border-primary/40 text-foreground/50 hover:text-primary transition-all duration-300 [&_svg]:size-5 [&_svg]:stroke-[1.5px]" />
          </div>
        </Carousel>
      </div>
    </section>;
}